"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RENOVATION_SAFEGUARD_LOGO_PATH = exports.RENOVATION_SAFEGUARD_BRAND_NAME = exports.CASETRUST_LOGO_ASPECT_RATIO = exports.CASETRUST_LOGO_PATH = exports.CASETRUST_BRAND_NAME = void 0;
/** User-facing CaseTrust brand name — always "CaseTrust", never "CASE Trust" or "Case Trust". */
exports.CASETRUST_BRAND_NAME = "CaseTrust";
/** Public asset path; each app serves this from its `public/` folder. */
exports.CASETRUST_LOGO_PATH = "/casetrust-logo.png";
/** Source asset is 545×248px; scale by height in UI (width auto). */
exports.CASETRUST_LOGO_ASPECT_RATIO = 545 / 248;
/** Handshake's own escrow brand for Interior Design (`workflow: "id"`) projects — not a CaseTrust accreditation. */
exports.RENOVATION_SAFEGUARD_BRAND_NAME = "Renovation Safeguard";
exports.RENOVATION_SAFEGUARD_LOGO_PATH = "https://gnlpoxemyesscbxnwumb.supabase.co/storage/v1/object/public/public-prod/assets/email_assets/renovation-safeguard.png";
